import { render, staticRenderFns } from "./FullPageLayout.vue?vue&type=template&id=2a5bdb76&"
import script from "./FullPageLayout.vue?vue&type=script&lang=ts&"
export * from "./FullPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./FullPageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports